import React from "react";

import { GroupCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function group({ width, onResize }: Column.Options) {
	return base(ColumnId.Group, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default group;
